import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export function HomePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 dark:from-gray-900 dark:to-gray-800">
      <header className="container mx-auto px-4 py-6">
        <nav className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="w-8 h-8 bg-primary rounded-full"></div>
            <span className="text-2xl font-bold text-primary">SixSight</span>
          </div>
          <Link to="/login">
            <Button variant="outline">Login</Button>
          </Link>
        </nav>
      </header>

      <main className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold mb-6 bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
            Cricket Analysis Reimagined
          </h1>
          <p className="text-xl text-muted-foreground mb-8 max-w-3xl mx-auto">
            Professional cricket analysis platform for academies, coaches, and players. 
            Real-time insights, comprehensive analytics, and AI-powered coaching.
          </p>
          <div className="space-x-4">
            <Link to="/login">
              <Button size="lg">Get Started</Button>
            </Link>
            <Button variant="outline" size="lg">
              Watch Demo
            </Button>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <Card>
            <CardHeader>
              <CardTitle>Real-time Analysis</CardTitle>
              <CardDescription>
                Instant shot analysis with physics-based calculations
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Advanced algorithms analyze ball trajectory, bat speed, and contact points
                to provide immediate feedback and coaching insights.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Multi-tenant Platform</CardTitle>
              <CardDescription>
                Built for academies with multiple teams and players
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Secure, scalable platform supporting multiple academies with
                role-based access control and customizable branding.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>AI-Powered Insights</CardTitle>
              <CardDescription>
                Personalized coaching recommendations and analysis
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Machine learning algorithms provide personalized coaching tips
                and identify improvement opportunities for each player.
              </p>
            </CardContent>
          </Card>
        </div>
      </main>

      <footer className="container mx-auto px-4 py-8 text-center text-muted-foreground">
        <p>&copy; 2024 SixSight. All rights reserved.</p>
      </footer>
    </div>
  );
}